import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4802Model } from '../kymw4802.model';
import { TargetCrossGoodsInfo } from '../vo/target-cross-goods-info.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 対象クロス商品情報更新サービス
 * @export UpdateTargetCrossGoodsInfoService
 * @class UpdateTargetCrossGoodsInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateTargetCrossGoodsInfoService extends PlessJsonResponderSub<any> {
  private model: KYMW4802Model;
  private successFunc: Function;
  private exceptionErrorFunc: Function;
  private vo: TargetCrossGoodsInfo;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateTargetCrossGoodsInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        updateTargetCrossGoodsInfo: {
          condition: {
            OrderCode: this.vo.orderCode,
            SelectOrderCode: this.vo.selectOrderCode,
            CrossCode: this.vo.crossCode,
            MediumType: this.vo.mediumType,
            PCode: this.vo.pcode,
          }
        },
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW4802Model} model モデルクラス
   * @param {TargetCrossGoodsInfo} vo 
   * @param {Function} successFunc 成功時後続処理
   * @memberof UpdateTargetCrossGoodsInfoService
   */
  execute(model: KYMW4802Model, vo: TargetCrossGoodsInfo, successFunc: Function, exceptionErrorFunc: Function): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.exceptionErrorFunc = exceptionErrorFunc;
    this.send('updateTargetCrossGoodsInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateTargetCrossGoodsInfoService
   */
  success(data: any): void {
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

  /**
   * API通信失敗時の処理
   *
   * @param {string} status エラーステータス
   * @param {*} result エラー結果
   * @memberof UpdateTargetCrossGoodsInfoService
   */
  exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
    this.dialogService.openAlertGetMessage('E0540');
  }
}
